import React from "react";
import { format } from "date-fns";

export const FormattedDate: React.FC<{
  value: Date;
}> = ({ value }) => {
  return <>{format(value, "MMM d 'at' h:mm aa")}</>;
};
